module.exports = __webpack_public_path__ + "img/reference01.4b430eca.jpg";